'use client';

import { AuthApi } from '@/apis/auth';
import { EApiBaseCode, ESessionErrorCode } from '@/constants';
import { getTouristDeviceIdForRequest, removeServerDeviceId } from '@/utils/device/server-device-id';
import { beginAccountOperation } from '@/utils/fetch/session-gate';
import { saveSessionExpiry } from '@/utils/fetch/session-storage';
import { syncArmsConfig } from '@/utils/sync-arms-config';

/** 同步清理回调纳入账号等待；后续 profile hydrate 与跳转由页面在返回后执行。 */
export async function requestAuthLogout(onSessionUpdated: () => void): Promise<{ user_id: string }> {
    const operation = beginAccountOperation();
    try {
        await operation.waitForPrevious();
        const device_id = await getTouristDeviceIdForRequest();
        if (!device_id) {
            throw new Error(ESessionErrorCode.DEVICE_ID_MISSING);
        }
        const res = await AuthApi.postLogout(device_id);
        if (res.code !== EApiBaseCode.SUCCESS || !res.data?.user_id) {
            throw new Error(res.message || ESessionErrorCode.LOGOUT_FAILED);
        }
        const expirySaved = saveSessionExpiry(res.data.access_expire_in);
        // 沿用现有设备存储清理；device_id 的值按接口契约保持不变。
        removeServerDeviceId();
        onSessionUpdated();
        syncArmsConfig();
        operation.finish({ accountSucceeded: true, expiryPersisted: expirySaved });
        if (!expirySaved) {
            throw new Error(ESessionErrorCode.SESSION_EXPIRY_NOT_PERSISTED);
        }
        return res.data;
    } catch (error) {
        operation.finish({ accountSucceeded: false, expiryPersisted: false });
        throw error;
    }
}
